<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item active">Nóminas</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-users"></i> Nóminas:
</h1>
<!-- end page-header -->

<panel [noButton]="true">
    <div class="row">
        <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-12">
            <div class="input-group">
                <input id="file" type="file" class="form-control" (change)="fileChageEvent($event)">
                <button type="button" [disabled]="!name_file" class="btn btn-outline-primary" (click)="uploadPayloadFile()">Cargar Archivo</button>
            </div>
        </div>
       
    </div>
    
</panel>